import { SiteChangeLog } from "../models/site";
import axiosConfig from "./axiosConfig";

const getSiteLog = async (
  authToken: string,
  siteId: string
): Promise<SiteChangeLog[]> => {
  const { data } = await axiosConfig.get(`/site/${siteId}/log`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default getSiteLog;
